export const WOMAPI = {
    genres: 'genre/movie/list',
    discover: 'discover/movie',
    top_rated: 'movie/top_rated',
    upcoming: 'movie/upcoming',
    search: 'search/movie',
    person: (id: number) => `person/${id}`,
    casts: (id: number) => `movie/${id}/credits`,
    movieDetail: (id: number) => `movie/${id}`,
    recommendationMovies: (id: number) => `movie/${id}/recommendations`,
};

export const errorMessages = {
    APIError: 'There is an error, please turn on the VPN and try again.',
};
